import { useCallback } from 'react';
import stripeApi from '../api/stripeApi';
import {
  APPS_PATH,
  ROUTER_BASE_PATH,
  SUCCESS_SEARCH_PARAM,
  CANCEL_SEARCH_PARAM,
} from '../constants';
import { buildUrlWithParam } from '../helpers';

interface CreateSessionProps {
  priceId: string;
  quantity: number;
}

const useCheckoutTopUpSession = () => {
  const [createCheckoutSession, { isLoading, isError }] =
    stripeApi.useCreateTopUpCheckoutSessionMutation();

  const createSession = useCallback(
    async ({ priceId, quantity }: CreateSessionProps) => {
      const successUrl = buildUrlWithParam(
        `${ROUTER_BASE_PATH}${APPS_PATH}`,
        SUCCESS_SEARCH_PARAM,
        true
      );

      const cancelUrl = buildUrlWithParam(
        window.location.href,
        CANCEL_SEARCH_PARAM,
        true
      );

      const response = await createCheckoutSession({
        quantity,
        priceId,
        successUrl,
        cancelUrl,
      }).unwrap();

      const { checkoutSessionUrl } = response;

      window.location.href = checkoutSessionUrl;
    },
    [createCheckoutSession]
  );

  return { createSession, isLoading, isError };
};

export default useCheckoutTopUpSession;
